import StorageKeys from "../../../const/StorageKeys";
import CacheStorage from "../../../service/storage/CacheStorage";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { NoticesListModel } from "../../../model/notices/NoticesListModel";
import { navigate } from "../../../service/navigation/Navigation";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import ShowToast from "../../../widget/common/ui/Toast";

const NoticesListProvider = new (class NoticesListProvider {
  navigate = (url: string, params: any = {}) => {
    if (UtilityHelper.isNotEmpty(url)) {
      navigate(url, params);
    }
  };

  getNoticesListAPI = async (): Promise<NoticesListModel | null> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}notice/following_notice_list`;
    const body: any = {
      account_id: accountId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const noticesListModel: NoticesListModel = response;
        return noticesListModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };

  deleteNoticeAPI = async (ids: Array<string>): Promise<boolean> => {
    ApiUrls.init();

    if (ids.length > 0) {
      const accountId: string =
        CacheStorage.getValue(StorageKeys.account_id) ?? "0";
      const url: string = `${ApiUrls.baseUrl}notice/delete_following_notices`;
      const body: any = {
        account_id: accountId,
        notice_id_list: ids.join(","),
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          return true;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }
    }

    return false;
  };
})();

export default NoticesListProvider;
